<template>
  <a href="#" @click.prevent="facebookLink(url)" class="btn-share">
    <svg width="23px" height="22px" viewBox="0 0 23 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>face copy</title>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="face-copy" transform="translate(1.000000, 0.000000)">
            <circle id="Oval" fill="#3C3C3C" cx="10.6666667" cy="11" r="11"></circle>
            <path d="M8.7449927,17 L8.7449927,11.7216091 L6.66666667,11.7216091 L6.66666667,9.23715078 L8.7449927,9.23715078 L8.7449927,7.34357006 C8.7449927,5.18972595 9.96559687,4 11.8351006,4 C12.7304303,4 13.6666667,4.16773299 13.6666667,4.16773299 L13.6666667,6.28172318 L12.6350912,6.28172318 C11.6186908,6.28172318 11.3016636,6.94433781 11.3016636,7.62393367 L11.3016636,9.23715078 L13.5706678,9.23715078 L13.2077855,11.7216091 L11.3016636,11.7216091 L11.3016636,17 L8.7449927,17 Z" id="Path" fill="#FFFFFF" fill-rule="nonzero"></path>
        </g>
    </g>
</svg>
  </a>
</template>

<script>
import objectToGetParams from '../../utils/objectToGetParams'
export default {
  name: 'facebook',
  components: {},
  computed: {
    baseUrl() {
      return process.env.BASE_URL
    }
  },
  methods: {
    facebookLink (url) {
      this.$emit('shared')
      window.open(
        `https://www.facebook.com/sharer/sharer.php` +
            objectToGetParams({
              u: url
            }),
        '__blank'
      )
    }
  },
  props: {
    url: {
      required: true,
      type: String
    },
    scale: {
      required: false,
      type: String
    }
  }
}
</script>
